import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';
import { RulesetEngine } from '../ruleset_engine/RulesetEngine';
import {
  EnumFeatureType,
  PG_PERCENT_OWNERSHIP_FLOOR,
} from '../../../../../../../constants';
import { LoanCategory } from '../../../../../../../../../../types/api';
import IsLoanCategoryEqualTo from './IsLoanCategoryEqualTo';
import { calculatePGPercentOwnership } from '../../../../../../../components/loan_application/utils/helpers';

export class PrincipalIsPGMustBeYes implements Rule {
  public evaluate(data: Partial<ApplicationFormValues>): boolean {
    const needsPG = RulesetEngine.evaluate(
      EnumFeatureType.PG,
      data as ApplicationFormValues
    );

    const percentageOwnershipIsLessThanPGPercentOwnershipFloor =
      calculatePGPercentOwnership(data.principals || []) <
      PG_PERCENT_OWNERSHIP_FLOOR;

    // Rules that allow user to opt out of providing a PG
    const isCorePropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.CORE_PROPCO
    ).evaluate(data);

    // Answer to question Principal Is Willing to be a Personal Guarantor must be Yes if:
    // - PG is required from Rulset Engine result
    // - Percentage ownership of PGs (Principals that selected Yes to PG) is less than PG_PERCENT_OWNERSHIP_FLOOR (50% or less)
    // e.g.: 2 PGs, one owns 51%, then the other one can opt out of providing a PG
    return needsPG && percentageOwnershipIsLessThanPGPercentOwnershipFloor;
  }
}

export default new PrincipalIsPGMustBeYes();
